import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppInsightsService } from './appinsights.service'

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [AppInsightsService]
})
export class CoreModule { }
